import { getContentWithoutTags } from 'core-components/helpers/getContentWithoutTags'
import { wrapListsInParagraph } from 'core-components/library/richTextEditor'

import { prepareDetailsElements } from './prepareDetailsElements'
import { prepareFigureElements } from './prepareFigureElements'
import { prepareSectionElements } from './prepareSectionElements'
import { prepareSeparatorElements } from './prepareSeparatorElements'
import { preparingTagsForNewEditorHTML } from './preparingTagsForNewEditorHTML'
import { removeEmptyLinks } from './removeEmptyLinks'
import { removeExtraDiv } from './removeExtraDiv'
import { wrapLinksInParagraph } from './wrapLinksInParagraph'

export const transformTextToNewEditor = (value: string | null | undefined) => {
  if (!value) {
    return ''
  }
  const valueWithoutTags = getContentWithoutTags(value)
  // Checking if the value is a string without tags we should wrap it in a <p> tag for the new Editor
  const valueWithTags = valueWithoutTags === value ? `<p>${value}</p>` : value

  const newValue = new DOMParser().parseFromString(valueWithTags, 'text/html')

  // This method removes extra sections from the old editor and does an
  // expandBlock conversion from the old editor to the new
  prepareSectionElements(newValue)

  //This method removes extra details as wrappers for details and empty details from old editor
  prepareDetailsElements(newValue)

  // Remove unnecessary figures
  prepareFigureElements(newValue)

  // This method finds separators in the old editor and converts them to the new editor
  prepareSeparatorElements(newValue)

  // if after all the transformations there are div tags left without attributes, then they need
  // to be replaced with p tags so that slate can insert them into the editor as text nodes
  removeExtraDiv(newValue)

  // if the content of the li tag is not a nested list, then the content must be wrapped
  // in a p tag to work correctly in the new editor
  const htmlStringWithCorrectLists = wrapListsInParagraph(newValue.body.innerHTML)

  // Delete the link if it is empty so as not to store extra nodes
  const htmlStringWithoutEmptyLinks = removeEmptyLinks(htmlStringWithCorrectLists)

  // After getting rid of empty links, we need to wrap them with a p tag if they are not already wrapped.
  // This is necessary so that they can be inserted into the editor
  newValue.body.innerHTML = htmlStringWithoutEmptyLinks

  wrapLinksInParagraph(newValue)

  // We pass the final line through the serialization and deserialization function so that the styles and
  // attributes in the tags take on the standard form for the new editor. and add a paragraph at the end, if
  // there was none, so that the document can be edited
  const finalHTMLString = preparingTagsForNewEditorHTML(newValue.body.innerHTML)

  return finalHTMLString
}
